/**
 * APP 內「去訂購」的統一入口：底部「瓦斯訂購」分頁、首頁叫桶、帳戶頁、優惠券頁等。
 * 2026-10 起改走點單機（/kiosk）；舊的 /gasShop 流程保留路由不刪，只是不再有入口導過去。
 */
export const ORDER_ENTRY_PATH = "/kiosk";
